'use client';
import { TheBoatAppLandingConfigType, useConfig } from '@marine/configs';
import { FC } from 'react';
import { SanityImage } from 'sanity-image';

type Props = {
  imageId: string;
  altText: string;
  imageDimensions: {
    width: number;
    height: number;
  };
};

const PostItemCardImage: FC<Props> = ({ imageId, altText, imageDimensions }) => {
  const { projectId, dataset } = useConfig<TheBoatAppLandingConfigType>();
  const { width, height } = imageDimensions;

  return (
    <SanityImage id={imageId} projectId={projectId} dataset={dataset} width={width} height={height} alt={altText} />
  );
};

export { PostItemCardImage };
